// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__g+HFV","spinner":"LoadingSpinner_spinner__lSdl2","spinner-container":"LoadingSpinner_spinner-container__0xGV1"};